import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import {connect} from "react-redux";
import {loginUser,resetLoginError} from "./actions";
import logo from '../../../../images/thoot.png';
import SiteFoot from '../../../../shared/components/footer/index';
import ReCAPTCHA from "react-google-recaptcha";

const recaptchaDisabled = process.env.REACT_APP_DISABLE_RE_CAPTCHA;

class SignIn extends React.Component {
    constructor (props){
        super(props);
        this.state = {
            email: '',
            password: '',
            rememberMe: false,
            recaptcha:'',
            emptyValidation: ''
        };
    }

    componentDidMount () {
        document.title = "Sign in to Kerenor booking";
    }

    onLoginClick (e) {
        const {email, password, rememberMe, recaptcha} = this.state;
        if (password.length === 0 && email.length === 0) {
            this.setState({emptyValidation: 'Email and Password fields are required.'})
        } else if (password.length === 0) {
            this.setState({emptyValidation: 'Password field is required.'})
        } else if (email.length === 0) {
            this.setState({emptyValidation: 'Email field is required.'})
        } else if(recaptcha === '' && !recaptchaDisabled) {
            this.setState({emptyValidation: 'Please fill recaptcha field.'})
        } else {
            this.setState({emptyValidation: ''})
            this.props.login({email, password, rememberMe});
        }
    }

    onInputChange (key, value) {
        this.setState({
            [key]: value
        })
    }

    handleKeyPress (e) {
        if (e.key === 'Enter') {
            if (this.state.password.length >= 6) {
                const {email, password, rememberMe} = this.state;
                this.props.login({email, password, rememberMe})
            } else {
                this.input && this.input.focus()
            }
        }
    }

    get loginError () {
        return this.props.auth.loginError;
    }

    get validationMessage () {
        return this.props.auth.validationMessage;
    }

    componentWillUnmount() {
        this.props.resetLoginError()
    }

    render() {
        if (this.props.auth.currentUser) {
            switch (this.props.auth.currentUser.role) {
                case 'super_admin' : {
                    return <Redirect to="/sm-admin"/>
                }
                case 'user' : {
                    return <Redirect to="/account"/>
                }
                default: {
                    return;
                }
            }
        }
        return (
            <div className="sign-in">
                <div className="sign-in__container">
                    <div className="main-block sign">
                        <div className="main-block__logo">
                            <Link to="/">
                                <img src={logo} alt="Kerenor Booking" width="300"/>
                            </Link>
                        </div>
                        {(this.loginError && !this.state.emptyValidation) && <small
                            className="sign-in__validation sign-in__validation--short">{(this.validationMessage) ? this.validationMessage : "The e-mail or password you entered is incorrect."}</small>}
                        {(this.state.emptyValidation) &&
                            <small className="sign-in__validation sign-in__validation--short">{this.state.emptyValidation}</small>}
                        <div className="main-block__form">
                            <form>
                                <div className="text-field"> {/*add has-error for error styles*/}
                                    <label className="text-field__label" htmlFor="">Email Address</label>
                                    <input
                                        placeholder="someone@xyz.com"
                                        type="email"
                                        className="text-field__input"
                                        autoFocus={true}
                                        onChange={e => this.onInputChange('email', e.target.value)}
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                    />
                                    <span className="error-message">Error Message</span>
                                </div>
                                <div className="text-field"> {/*add has-error for error styles*/}
                                    <label className="text-field__label" htmlFor="">Password</label>
                                    <input
                                        placeholder="Password"
                                        type="password"
                                        className="text-field__input"
                                        //getRef={input => this.input = input}
                                        onChange={e => this.onInputChange('password', e.target.value)}
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                    />
                                    <span className="error-message">Error Message</span>
                                </div>
                                <div className="main-block__item">
                                    <div className="checkbox custom-control custom-checkbox">
                                        <input id="sign-in" type="checkbox" className="custom-control-input"
                                               onChange={e => this.onInputChange('rememberMe', e.target.checked)}/>
                                        <label htmlFor="sign-in" className="checkbox-label custom-control-label">Remember
                                            me</label>
                                    </div>
                                    <Link className="btn btn-link" to="/forget-password">Forgot your password?</Link>
                                </div>
                                {!recaptchaDisabled ? (
                                    <div className="text-field recaptcha_block"> {/*add has-error for error styles*/}
                                        <ReCAPTCHA
                                            sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                                            size="normal"
                                            onChange={(token) => this.onInputChange('recaptcha', token)}
                                        />
                                        <span className="error-message">Error Message</span>
                                    </div>
                                ) : null}
                            </form>
                        </div>
                        <div className="main-block__buttons">
                            <Link to="/sign-in" className="btn btn-secondary" onClick={e => this.onLoginClick(e)}>Sign
                                In</Link>
                            <p>
                                Don't have an account?
                                <Link to="/registration" className="btn btn-link">Register</Link>
                            </p>
                        </div>
                        <SiteFoot className="copyright"/>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        store: state.signInUser,
        auth: state.auth,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        login: (params) => dispatch(loginUser(params)),
        resetLoginError: () => dispatch(resetLoginError()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Signin/index.js